import { render, staticRenderFns } from "./DirectInviteSpeaker.vue?vue&type=template&id=b0e812b0&"
import script from "./DirectInviteSpeaker.vue?vue&type=script&lang=js&"
export * from "./DirectInviteSpeaker.vue?vue&type=script&lang=js&"
import style0 from "./DirectInviteSpeaker.vue?vue&type=style&index=0&id=b0e812b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports